export const GET_APPLICATIONS = 'GET_APPLICATIONS';
export const GET_APPLICATIONS_SUCCESS = 'GET_APPLICATIONS_SUCCESS';
export const GET_APPLICATIONS_FAILURE = 'GET_APPLICATIONS_FAILURE';
export const CONNECT_OUTREACH = 'CONNECT_OUTREACH';
export const CONNECT_INTERCOM = 'CONNECT_INTERCOM';
export const CONNECT_GONG = 'CONNECT_GONG';
export const CONNECT_ZENDESK = 'CONNECT_ZENDESK';
export const CONNECT_ZENDESK_SUCCESS = 'CONNECT_ZENDESK_SUCCESS';
export const CONNECT_ZENDESK_FAILURE = 'CONNECT_ZENDESK_FAILURE';
export const CONNECT_OUTREACH_SUCCESS = 'CONNECT_OUTREACH_SUCCESS';
export const CONNECT_OUTREACH_FAILURE = 'CONNECT_OUTREACH_FAILURE';
export const CONNECT_INTERCOM_SUCCESS = 'CONNECT_INTERCOM_SUCCESS';
export const CONNECT_INTERCOM_FAILURE = 'CONNECT_INTERCOM_FAILURE';
export const CONNECT_GONG_SUCCESS = 'CONNECT_GONG_SUCCESS';
export const CONNECT_GONG_FAILURE = 'CONNECT_GONG_FAILURE';
export const DISCONNECT_APP = 'DISCONNECT_APP';
export const DISCONNECT_APP_SUCCESS = 'DISCONNECT_APP_SUCCESS';
export const DISCONNECT_APP_FAILURE = 'DISCONNECT_APP_FAILURE';
export const SEND_CODE_OUTREACH = 'SEND_CODE_OUTREACH';

export interface IOutreachConnectPayload {
	client_id: string;
	client_secret: string;
	redirect_uri: string;
}

export interface IIntercomConnectPayload {
	access_token: string;
}

export interface IGongConnectPayload {
	client_id: string;
	client_secret: string;
}

export interface IZendeskConnectPayload {
	domain: string;
	email: string;
	'zendesk password': string;
}
